import "@Styles/mandate.css";
import arrowleft from "@Images/NewUI/Vector.png";
import React, { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import repayBottomIng from "../../../../src/Images/NewUI/repaybtmimg.png";
import UpiIcon from "../../../../src/Images/NewUI/upiicon.png";
import upilable from "../../../../src/Images/NewUI/upilable.png";
import upilogos from "../../../../src/Images/NewUI/upilogos.png";
import { getWithdrawDetails } from "@Redux/ApplyLoan/action";
import Heading from "../Common/MainHeading";
import { HEADING_LOANREPAY } from "../Common/constant";

import { getStatus, upiPay } from "@Redux/Payment/Payment";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Loader } from "../../NewUI/Common/Loader";
import {
  getLoanData,
  getWithdrawLoanData,
} from "../../../Redux/ApplyLoan/action";
import { getUserDetail } from "../../../Redux/GeneralDetails/action";
import { withRouter } from "../../../hooks/withRouter";
import ToastMsg from "../../../helper/ToastMsg";

const LoanRepay = (props) => {
  const navigate = useNavigate();
  // const loanData = JSON.parse(
  //   new URLSearchParams(window.location.search)?.get("loanDetails")
  // );
  const from = new URLSearchParams(window.location.search)?.get("from");
  // console.log(from, "frr");
  const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  const [amount, setAmount] = useState(null);
  const [dueAmount, setDueAmount] = useState(null);
  const [convenince, setConvenince] = useState(null);
  const [loanDetails, setLoanDetails] = useState(null);
  const [finalAmount, setFinalAmount] = useState(null);
  const [totalPayAmount ,setTotalPayAmount] = useState(null);
  const [isChecked, setIsChecked] = useState(true);
  const [defaultChecked, setDefaultChecked] = useState(true);
  const [loader, setLoader] = useState(false);
  const [note, setNote] = useState(null);
  // const [note, setNote] = useState(null);
  const [paybleAmount, setPaybleAmount] = useState(0);
  const [upiAddress, setUpiAddress] = useState("");
  const [amountType, setAmountType] = useState("dueAmount");
  const [loanDatanew, setLoanData] = useState([]);
  
  const fnC = async (value) => {
    if (value <= dueAmount) {
      setAmount(value); 
    } else {
      setAmount(dueAmount);
    }
  };
  
  function formatToINR(amount) {
    return amount.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      useGrouping: true,
    });
  }
//   function formatToINR(amount) {
//     return amount.toLocaleString('en-IN', {
//         maximumFractionDigits: 2,
//         useGrouping: true
//     });
// }
const handleChangeAmount = async (e) => {
  let value = e.target.value;

  if (value === "" || isNaN(value)) {
    setAmount("");
    setFinalAmount(0)
    return;
  }

  value = parseInt(value); 
  await fnC(value);

  await taxCalculationEnterAmount(
    loanDetails,
    value < dueAmount ? value : dueAmount
  );
};
  const redirectToPayment = () => {
  
    let paymentDetails = {
      amount: Math.round(paybleAmount),
      note: note,
      convenince: Math.round(convenince),
      paymentGatewayType: loanDetails?.payment_gateway,
    };
    navigate(
      `/upi-payment?paymentDetails=${JSON.stringify(paymentDetails)}`
    );
  };
 
  useEffect(() => {
    handleWithdrawLoan();
  }, []);
  const handleWithdrawLoan = () => {
    props.getWithdrawDetails(token)
      .then((res) => {
        setLoader(false);
        setLoanData(res?.data?.data);
        // console.table("response loan Status", res?.data?.data);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  useEffect(() => {
    setLoader(true)
   

    let data = {};
    
    if (from == "withdraw" || from =="preclosure") {
       // console.log(from, "formmmmm");
      // alert("jhdgfjh")
      props
        .getWithdrawLoanData(from, token)
        .then((res) => {
          setLoader(false)
          if (res.status === 200) {
            setLoader(false)
            const loanData = res.data.data;
            setDueAmount(loanData?.due_amount);
            setLoanDetails(loanData);
            // console.log("loanData", res?.data?.data);
            taxCalculation(loanData);
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
            window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
        });
    } else {
      props
        .getLoanData(data, token)
        .then((res) => {
          if (res.status === 200) {
            setLoader(false)
            const loanData = res.data.data;
            // setDueAmount(loanData?.due_amount);
            setDueAmount(loanData?.due_amount);
            setLoanDetails(loanData);
            // console.log("loanData", res?.data?.data);
            taxCalculation(loanData);
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
            window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
        });
    }
  }, []);
  // console.log(loanDetails, "loanDetails******");
  const handleAmount = (amountType, amount) => {
    setPaybleAmount(0);
    // setFinalAmount(0);
    if (amountType === "dueAmount") {
      setAmountType("dueAmount");
      taxCalculation(loanDetails);
      // setDueAmount(amount);
      setDueAmount(amount);
      setAmount("");
      setIsChecked(true);
      setDefaultChecked(true);
    }
    if (amountType === "enterAmount") {
      setAmountType("enterAmount");
      setAmount("");
      setIsChecked(false);
      setDefaultChecked(false);
    }
  };

  const taxCalculation = (data) => {
    let taxDetails = data;
    let taxAmount = (taxDetails?.due_amount * taxDetails?.tax) / 100;
    let gstAmount = (taxAmount * 18) / 100;
    let finalAmount = gstAmount + taxAmount + taxDetails?.due_amount;
    setConvenince(gstAmount + taxAmount);
    setFinalAmount(finalAmount);
    setTotalPayAmount(finalAmount)
    setPaybleAmount(taxDetails?.due_amount);
    return finalAmount;
  };
  const taxCalculationEnterAmount = (data, value) => {
    let taxDetails = data;
    let taxAmount = (value * taxDetails?.tax) / 100;
    let gstAmount = (taxAmount * 18) / 100;
    let finalAmount = gstAmount + taxAmount + Number(value);
    setConvenince(gstAmount + taxAmount);
    setFinalAmount(finalAmount);
    setPaybleAmount(value);
    return finalAmount;
  };

  const [btnDisable, setBtnDisable] = useState(false);

  const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)+$/;
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      show: false,
      transId: "",
      upiAddress: "",
      trasDetail: "",
      minutes: 0,
      seconds: 0,
      loanData: JSON.parse(
        new URLSearchParams(window.location.search)?.get("paymentDetails")
      ),
    }
  );
  const [timeLeft, setTimeLeft] = useState(0);

  const handleClose = (type) => {
    if (type === "delay") {
      setState({ show: false });
      navigate("/super-loan-dashboard");
    } else {
      setState({ show: false });
    }
  };
  const handleShow = () => {
    setState({ show: true });
  };
 
  const handleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
    if (e.target.value.match(regex) && e.target.value.length > 5) {
      setBtnDisable(false);
    } else if (!e.target.value.match(regex) || e.target.value.length < 5) {
      setBtnDisable(true);
    }
  };
  const submitPayment = () => {
    setLoader(true)
  console.log("llaoder");
  
    setTimeout(() => {
    let token = props?.user?.User?.token || localStorage.getItem("gpay_token");
    let data = {
      amount: from !== "'withdraw'" ? finalAmount : loanDatanew?.payable_amount,
      note: "Transaction",
      upi_address: state?.upiAddress,
      fee: convenince.toFixed(2),
    };
    
    // console.log(loanDetails?.payment_gateway, "fhjhkjlkjh");
    props
      .upiPay(data, token, loanDetails?.payment_gateway)
      .then((res) => {
      
        if (res.status === 200) {
          setLoader(false)
          
          // console.log("hi i am in 1");
          if (loanDetails?.payment_gateway !== "icici") {
            let transId = res?.data?.data?.transaction_id;
            // console.log("hi i am in 2");
            setState({ transId: transId });
            // console.log("hi i am in 3");
            getPaymentStatus(transId);
            // console.log("hi i am in");
            setTimeout(() => {
            window.open(res?.data?.data?.url, "_blank");
          }, 100);
          } else {
            let transId = res?.data?.trasaction_id;
            setState({ transId: transId });
            getPaymentStatus(transId);
          }
          handleShow();
          setTimeLeft(90);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        if (err.response?.status === 400) {
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
        }
      });
    }, 2000);
  };
  const getPaymentStatus = (transId) => {
    let token = props?.user?.User?.token || localStorage.getItem("gpay_token");
    let data = {
      transaction_id: transId,
    };
    props
      .getStatus(data, token)
      .then((res) => {
        if (res.status === 200) {
          setState({ trasDetail: res.data });
          if (res.data.status === "CREDITED")
            navigate(
              `/upi-payment-success?paymentDetails=${JSON.stringify(res.data)}`
            );
        }
        if (res.data.status === "FAILURE") {
          navigate(
            `/upi-payment-fail?paymentDetails=${JSON.stringify(res.data)}`
          );
        }
        if (res.data.status === "IN PROCESS") {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };

 

  useEffect(() => {
    if (timeLeft === 0) {
      setTimeLeft(null);
    }
  }, []);

  useEffect(() => {
    if (state?.transId && timeLeft > 0) {
      const interval = setInterval(() => {
        getPaymentStatus(state?.transId);
        setTimeLeft(Number(timeLeft) - 2);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [timeLeft]);

  let { show, transId, minutes, seconds } = state;

  return (
   <>
   
   <div className="  sticky-header pb-0 ">
          {/* <Heading headingText={HEADING_LOANREPAY} history={props.history} /> */}
          <div  className="shadowline sticky-header d-flex align-items-center mt-20">
            
          <a
                  onClick={(e) => {
                    window.location.href=("/super-loan-dashboard")
                  }}
                >
                  <img style={{paddingLeft:"32px", paddingRight:"20px"}} src={arrowleft} />
                </a>

                <div className="mt-2">
                  <span className=" loanapplicationemi">Loan Repayment</span>
                 
                </div>
            {/* <Heading
              headingText={HEADING_COMPLETEPROFILE}
              history={props.history}
              setModalState={setModalState}
              
            /> */}
          </div>
        </div>
    <div id="backgroundhere" className="main_div toolbarRespo2">
      {loader ? <Loader /> : null} 
     
        
      <div className="container ">
        
        <div className="pb-4 flexcentrenew">
          <div className="text-center repay_main ">
            <img
              className="mt-20 mb-35 repayuifix"
              
              src={upilable}
              alt="upi_img"
            />
            
            <span style={{display:"flex", flexDirection:"row", justifyContent:"center"}} className="Total_amount  newtotalamount ">
              
            <span style={{ fontWeight:"400", marginRight:"5px"}}>₹</span> 
            
            {from !== "'withdraw'" ? finalAmount : loanDatanew?.payable_amount}

            </span>
            <img
              className="pad-20 upilogoswidth"
              src={upilogos}
              alt="upi_img"
            />
            
          </div>


           {from !== "preclosure" ?
          <div className="toggle card-height-small w-100 mx-auto ">
            <div className="d-flex flex-column justify-content-between">
              <div className="pt-0 pb-0 amount_select superapppadding mb-20">
                {amountType === "dueAmount" ? (
                  <div className="repayoutline">
                    <div className="repayoutlineinner">
                      <input
                        type="radio"
                        name="gender"
                        id="Pay_Total_Due"
                        value="Pay_Total_Due"
                        className="custom-radio"
                        checked={defaultChecked}
                        onClick={() => handleAmount("dueAmount", dueAmount)}
                      />
                      <label
                        for="Pay_Total_Due"
                        // style={{ paddingLeft: "10px", }}
                        className="reapytext"
                      >
                        Pay Total Due
                      </label>
                      <br />
                      <span style={{ paddingLeft: "24px",  fontSize: "16px", fontWeight: "400"  }}>₹ {from !== "'withdraw'" ? totalPayAmount : loanDatanew?.payable_amount}</span>
                    </div>
                  </div>
                ) : (
                  <div className="repayoutlinenotselected">
                    <div className="repayoutlineinner">
                      <input
                        type="radio"
                        name="gender"
                        id="Pay_Total_Due"
                        className="custom-radio"
                        value="Pay_Total_Due"
                        checked={defaultChecked}
                        onClick={() => handleAmount("dueAmount", dueAmount)}
                      />
                      <label
                        for="Pay_Total_Due"
                        style={{ paddingLeft: "10px" }}
                        className="reapytext"
                      >
                        Pay Total Due
                      </label>
                      <br />
                      <span style={{ paddingLeft: "24px", fontSize: "16px", fontWeight: "400"  }}>₹ {from !== "'withdraw'" ? totalPayAmount : loanDatanew?.payable_amount}</span>
                    </div>
                  </div>
                )}

                <br />
                {amountType === "enterAmount" && (from !== "'withdraw'" ||from !== "preclosure") ? (
                  <div style={{marginTop: "-10px"}} className="repayoutline">
                    {from !== "withdraw" ?
                    <div className="repayoutlineinner">
                      <input
                        type="radio"
                        name="gender"
                        id="Enter_Amount"
                        value="Enter_Amount"
                        // onClick={() => handleAmount("enterAmount", 0)}
                      />
                      {/* {from =="preclosure" ?} */}
                      <label for="Enter_Amount" className="reapytext" style={{ paddingLeft: "10px" }}>
                        Enter An Amount
                      </label>
                      <br />
                      <span style={{ paddingLeft: "24px" }}>
                      ₹
                        <input
                          type="number"
                          className="enter_amount"
                          placeholder=" "
                          name="amount"
                          value={amount}
                          disabled={isChecked ? isChecked : false}
                          onChange={handleChangeAmount}
                          onClick={() => handleAmount("enterAmount", 0)}
                        />
                      </span>
                    </div>:""}
                  </div>
                ) : ( ( from !== "withdraw" || from !== "preclosure")  ?
                (
                  
                  <div className={from !== "'withdraw'" ? "repayoutlinenotselectedtwo" : ""}>

                    {from !== "'withdraw'" &&
                    <div className="repayoutlineinner">
                      <input
                        type="radio"
                        name="gender"
                        id="Enter_Amount"
                        value="Enter_Amount"
                        onClick={() => handleAmount("enterAmount", 0)}
                      />
                      <label for="Enter_Amount" className="reapytext" style={{ paddingLeft: "10px" }}>
                        Enter An Amount
                      </label>
                      <br />
                      <span style={{ paddingLeft: "24px" }}>
                      <input
                        type="number"
                        className="enter_amount"
                        placeholder="₹"
                        name="amount"
                        value={amount} 
                        disabled={isChecked ? isChecked : false}
                        onChange={handleChangeAmount}
                        onClick={() => handleAmount("enterAmount", 0)}
                      />
                      </span>
                    </div>}

                  </div>)
                : null)}
              </div>
            </div>
            
          </div>: ""}

          {loanDetails?.payment_gateway == "icici" ? (
            <div className="lower_payment_div upi_payment">
              {" "}
              <label>Please enter UPI ID:</label>{" "}
              <input
                type="text"
                style={{height:"60px"}}
                className="upiidinputdesign"
                placeholder=" eg. yournumber@paytm"
                name="upiAddress"
                value={state?.upiAddress}
                onChange={handleChange}
              />
              <img
                className="upiIconfix"
                width={36}
                height={36}
                src={UpiIcon}
              ></img>
            </div>
          ) : (
            ""
          )}
        

         <div className="sticky-button-container justifycontentrepay mt-20vh">
          <div className={`text-center  pt-4 ${!btnDisable ? "PayNowBtn getLimitbtn" : "PayNowBtn blur getLimitbtn"}`}>
           <div>

           {loanDetails?.payment_gateway == "icici" ? (
              <>
                {btnDisable ? (
                  <div>
                    Pay Now  
                  </div>
                ) : (
                  <div
                    onClick={submitPayment}
                    className=" "
                    disabled={finalAmount === 0}
                  >
                    Pay Now  
                  </div> 
                )}
              </>
            ) : (
              <div
                onClick={submitPayment}
                disabled={finalAmount === 0}
              >
                Pay Now  
              </div>
            )}
           </div>

           
          </div>
          <div>
           <img
              className="mt-20"
              width={138}
              height={60}
              src={repayBottomIng}
              alt="upiPageimg"
            />
           </div>
          </div>
        </div>
        <div className="">
        <Modal show={show} onShow={handleShow} centered className="loan_mn">
          {" "}
          <Modal.Body>
            {" "}
            <div className="popup-div" style={{ textAlign: "center" }}>
              {" "}
              {/* {timeLeft === 0 ? (
                
                <span className="">
                  {" "}
                  It taking too much time to get response, we will notify when
                  payment is update!{" "}
                </span>
                
              ) : (
                
                <span className="">
                  {" "}
                  Please accept the request from PayMe on your UPI app!{" "}
                </span>
                
              )} */}
            </div>{" "}
            <div class="d-flex justify-content-center">
            {timeLeft === 0 ? (
                
                <span className="">
                  {" "}
                  It taking too much time to get response, we will notify when
                  payment is update!{" "}
                </span>
                
              ) : (
                
                <span className="">
                  {" "}
                  Please accept the request from MMB on your UPI app!{" "}
                </span>
                
              )}
                
              {" "}
              
            </div>{" "}
            <div style={{display:"flex", flexDirection:"column"}} className="text-center pt-4 ">

            <div class="spinner-border mb-12" role="status">
                {" "}
                <span class="visually-hidden">Loading...</span>{" "}
              </div>{" "}

              {" "}
              <button
                onClick={
                  timeLeft === 0 ? () => handleClose("delay") : handleClose
                }
                className="PayNowBtnupi bg-orange text-white  "
                style={{ width: "100%" }}
              >
                {" "}
                Cancel{" "}
              </button>{" "}
            </div>{" "}
          </Modal.Body>{" "}
        </Modal>
        </div>
      </div>
    </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withRouter(connect(mapStateToProps, {
  getLoanData,
  getWithdrawLoanData,
  getUserDetail,
  getWithdrawDetails,
  upiPay,
  getStatus,
})(LoanRepay));